<template>
  <form @submit.prevent="submit">
    <Field
      label="Display Title"
      @input="$v.resource.name.$touch()"
      v-model="resource.name"
      placeholder="e.g. Page banner"
      helpText="This is for internal use only"
      :error="nameError"
    />

    <Field
      label="Heading"
      v-model="resource.title"
      helpText="This displays above the content on your website"
    />

    <Field
      hidden
      label="Content Type"
      type="select"
      @input="$v.resource.list_type_id.$touch()"
      v-model="resource.list_type_id"
      :error="list_type_idError"
      :options="listTypes"
    />

    <Field
      hidden
      label="weight"
      @input="$v.resource.weight.$touch()"
      v-model="resource.weight"
      :error="weightError"
      helpText="This is the order which the content will be on the page"
    />

    <Btn primary>Submit</Btn>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'EditListForm',

  mixins: [form],

  components: {
    Btn
  },

  props: {
    listTypes: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...errorMessages(['name', 'list_type_id', 'weight'])
  },

  validations: {
    resource: {
      name: {required},
      list_type_id: {required},
      weight: {required}
    }
  }
}
</script>
